export interface Coordinates {
  latitude: number;
  longitude: number;
}

const LONDON_FALLBACK: Coordinates = { latitude: 51.5074, longitude: -0.1278 };

export function getFallbackCoordinates(): Coordinates {
  return LONDON_FALLBACK;
}
